export * from './McGame'



// WEBPACK FOOTER //
// src/pages/MC/Game/index.js